// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SecurityCorrelationsHeader, { SELECT_ALL, CLEAR_ALL } from './SecurityCorrelationsHeader';
import SecurityCorrelationsHeaderNav from './SecurityCorrelationsHeaderNav';
import SecurityCorrelationsQuestions from './SecurityCorrelationsQuestions';


class SecurityCorrelations extends Component {
  constructor(props) {
    super(props);

    this.onSelectEssentialCorrelations = this.onSelectEssentialCorrelations.bind(this);
    this.onSelectAllCorrelations = this.onSelectAllCorrelations.bind(this);
    this.onClearAllCorrelations = this.onClearAllCorrelations.bind(this);
  }

  onSelectEssentialCorrelations() {
    const {
      onBatchAnswerCorrelations,
      allCorrelations,
      essentialCorrelations
    } = this.props;
    let yesIds = essentialCorrelations.map(correlation => correlation.id);
    let noIds = allCorrelations.map(correlation => correlation.id)
      .filter(cid => yesIds.indexOf(cid) < 0);
    return onBatchAnswerCorrelations(yesIds, noIds);
  }

  onSelectAllCorrelations() {
    const { onBatchAnswerCorrelations, allCorrelations } = this.props;
    let yesIds = allCorrelations.map(correlation => correlation.id);
    return onBatchAnswerCorrelations(yesIds);
  }

  onClearAllCorrelations() {
    const { onBatchAnswerCorrelations, allCorrelations } = this.props;
    let clearIds = allCorrelations.map(correlation => correlation.id);
    return onBatchAnswerCorrelations(null, null, clearIds);
  }

  render() {
    const {
      baseNavRoute,
      completedCategoriesCount,
      categories,
      onAnswer,
      answeredCorrelations,
      area,
      activeAreaIds,
      areas,
      abilities
    } = this.props;

    const secondaryAction =
      answeredCorrelations.length ?
      CLEAR_ALL :
      SELECT_ALL;

    return (
      <div className='security-correlations'>
        <div className='container'>
          <section className='content-wrapper svp-common-ui'>
            <SecurityCorrelationsHeader
              baseNavRoute={baseNavRoute}
              canEditUsage={abilities.canEditUsage}
              completedCategoriesCount={completedCategoriesCount}
              totalCategoriesCount={categories.length}
              onSelectEssentialCorrelations={this.onSelectEssentialCorrelations}
              onSelectAllCorrelations={this.onSelectAllCorrelations}
              onClearAllCorrelations={this.onClearAllCorrelations}
              secondaryAction={secondaryAction}
              area={area}
              activeAreaIds={activeAreaIds}
              areas={areas}
            />
            <SecurityCorrelationsQuestions
              categories={categories}
              onAnswer={onAnswer}
            />
            <SecurityCorrelationsHeaderNav
              baseNavRoute={baseNavRoute}
              canEditUsage={abilities.canEditUsage}
              activeAreaIds={activeAreaIds}
              areas={areas}
            />
          </section>
        </div>
      </div>
    );
  }
}

SecurityCorrelations.propTypes = {
  completedCategoriesCount: PropTypes.number.isRequired,
  categories: PropTypes.array.isRequired,
  onAnswer: PropTypes.func.isRequired,
  onBatchAnswerCorrelations: PropTypes.func.isRequired,
  essentialCorrelations: PropTypes.array.isRequired,
  allCorrelations: PropTypes.array.isRequired,
  answeredCorrelations: PropTypes.array.isRequired,
  area: PropTypes.object,
  activeAreaIds: PropTypes.array,
  areas: PropTypes.array,
  abilities: PropTypes.object.isRequired,
  baseNavRoute: PropTypes.string.isRequired
};

export default SecurityCorrelations;



// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelations.js